export default __webpack_public_path__ + "static/media/Empathy.be2d1111.svg";